import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";

class VehiclePhotos extends Component {
  state = {
    rows: [],
  };

  componentDidMount() {
    this.loadData(this.props);
  }

  loadData = (props) => {
    const rows = [];
    if (props.record !== undefined) {
      const roots = _.get(props.record, "edmunds[0].results[0].root");
      if (roots === undefined) {
        rows.push(
          <Table.Row key={`veh_no_photo_${props.detailIndex}`}>
            <Table.Cell colSpan={100}>No sample photo available</Table.Cell>
          </Table.Row>
        );
      } else {
        _.forEach(roots, (root, index) => {
          const subType = _.get(root, "$.subType");
          const shotTypeAbbreviation = _.get(
            root,
            "$.shotTypeAbbreviation",
            ""
          );
          const captionTranscript = _.get(root, "captionTranscript[0]._", "");
          if (
            subType === "exterior" &&
            shotTypeAbbreviation.includes("_FQ_RQ_O_PROFILE")
          ) {
            _.forEach(_.get(root, "photoSrcs"), (photoSrc, photoSrcIndex) => {
              const src = _.get(photoSrc, "_");
              if (src.includes("_500.jpg")) {
                rows.push(
                  <Table.Row key={`veh_phot_cap_${index}_${photoSrcIndex}`}>
                    <Table.Cell colSpan={100}>
                      Sample: {captionTranscript}
                    </Table.Cell>
                  </Table.Row>
                );
                const background = `http://media.ed.edmunds-media.com${src}`;
                rows.push(
                  <Table.Row key={`veh_phot_cap_${index}_${photoSrcIndex}`}>
                    <Table.Cell colSpan={100}>
                      <Table
                        key={`veh_phot_${index}_${photoSrcIndex}`}
                        style={{ background: { background } }}
                      >
                        <Table.Body>
                          <Table.Row>
                            <Table.Cell />
                          </Table.Row>
                        </Table.Body>
                      </Table>
                    </Table.Cell>
                  </Table.Row>
                );
              }
            });
          }
        });
      }
    }
    this.setState({ rows });
  };
  render() {
    return (
      <Table>
        <Table.Body>
          <Table.Row key={`vin_samp_photo_row`}>
            <Table.HeaderCell
              colSpan={100}
              className="report-sub-section-header text-center"
            >
              Sample Vehicle Photos
            </Table.HeaderCell>
          </Table.Row>
          {this.state.rows}
        </Table.Body>
      </Table>
    );
  }
}

export default VehiclePhotos;



// WEBPACK FOOTER //
// ./src/components/reports/Platinum/VehiclePhotos.js